import React from 'react'
import './school-signup-component-v2.scss'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import SchoolSignUp from '../../school-request-demo/school-sign-up'
import Loading from '../../common/loading/loading'
import Path from '../../routes/routes-path'
import MasterDataApi from '../../../apis/master-data'
import SchoolApi from '../../../apis/school'
import CommonApi from '../../../apis/common'
import SignupSuccessComponent from './sign-up-success-component-v2/sign-up-success-component'

class SchoolSignupComponent extends React.Component {
    state = {
        activeTabIndex: 1,
        classDropdownData: null,
        sectionDropdownData: null,
        boardDropdownData: null,
        staffTypesDropdown: null,
        isSignUpfailed: false,
        isEmailAlreadyRegistered: false,
        isLoginFailed: false,
        loading: false,
        signUpEmail: null,
        isSignupSuccess: false,
        name: ''
    }

    countryCodeHash = {}

    tabs = [{ name: 'Signup' }]

    componentDidMount() {
        this.getBoardDetails()
        this.getClassDetails()
        this.getStaffTypesDetails()
        this.getCountryCodes()
    }

    onCountryCodeSearch(value, index) {
        if (value.length > 2 || !value) {
            this.countryCodeIndex = index
            this.getCountryCodes({ name: `/${value}` })
        }
    }

    getBoardDetails() {
        let payload = { limit: 100, display: 'SHOW' }
        MasterDataApi.getBoard(payload)
            .then(boardData => {
                let items = []
                for (let i = 0; i < boardData.response.length; i++) {
                    items.push({
                        title: boardData.response[i].title,
                        value: boardData.response[i].title
                    })
                }

                this.setState({ boardDropdownData: items, boardDropdownLoading: false })
            })
            .catch(err => {
                this.setState({
                    boardDropdownLoading: false
                })
            })
    }

    getClassDetails() {
        let payload = { limit: 100, sortType: 'asc', sortKey: 'title' }

        MasterDataApi.getClass(payload)
            .then(classData => {
                let items = []
                for (let i = 0; i < classData.response.length; i++) {
                    if (classData.response[i].title == 'Class 5') continue
                    items.push({
                        title: classData.response[i].title,
                        value: classData.response[i].title
                    })
                }

                this.setState({
                    classDropdownLoading: false,
                    classDropdownData: items
                })
            })
            .catch(err => {
                this.setState({
                    classDropdownLoading: false
                })
            })
    }

    getStaffTypesDetails() {
        let payload = { limit: 100 }
        payload.types = "nin/COORDINATOR"
        SchoolApi.getAllStaffTypes(payload)
            .then(staffTypes => {
                let items = []
                for (let i = 0; i < staffTypes.response.length; i++) {
                    items.push({
                        title: staffTypes.response[i].displayType,
                        value: staffTypes.response[i].type
                    })
                }
                this.setState({ staffTypesDropdown: items })
            })
            .catch(err => { })
    }

    getCountryCodes(payload = {}) {
        CommonApi.getCountryCodeList(payload)
            .then(response => {
                
                let data = response.response
                if (data.length) {
                    this.setState({ countryList: data })
                    let countryCodeDropdown = this.buildCountryCodeDropdown(data)
                    this.setState({ countryCodeDropdown })
                }
            })
            .catch(err => { })
    }

    buildCountryCodeDropdown(list = []) {
        let countryCodeDropdown = []
        let localHash = {}
        for (let i = 0; i < list.length; i++) {
            let item = list[i]

            if (!localHash[item.dialCode]) {
                this.countryCodeHash[item.dialCode] = item
                localHash[item.dialCode] = item
                countryCodeDropdown.push({
                    title: `${item.dialCode}`,
                    addOn: item.name,
                    value: item.dialCode
                })
            }
        }
        this.setState({ hashedCountryCode: this.countryCodeHash })
        return countryCodeDropdown
    }

    goToMenu() {
        this.props.history.replace(Path.DASHBOARD)
    }

    setSignupSuccess = name => {
        this.setState({
            isSignupSuccess: true,
            name: name
        })
    }

    render() {
        const { isSignupSuccess, name } = this.state
        return (
            <>
                {this.state.loading && <Loading />}
                <div className='container-fluid signup-component-v2'>
                    <div className='header row no-gutters'>
                        <div className='col-6'>
                            <a href='https://countingwell.com'>
                                <img
                                    alt=''
                                    className='logo'
                                    src={getImageSource(ImageConstants.CW_LOGO)}
                                />
                            </a>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 signup-container'>
                            {!isSignupSuccess && (
                                <>
                                    <div className='maths-day-container'>

                                        <div class='maths-day-description'>
                                            <p className='slogan-text-signup'>
                                                Request For Countingwell Application Demo
                                            </p>
                                            <p>
                                                Learning Maths with Countingwell is personalized and self-paced for each
                                                student. In addition, personalized homework allows teachers to facilitate
                                                effective learning
                                            </p>
                                        </div>

                                        <div className="mt-5">
                                            <img
                                                alt=''
                                                className='signup-image-web'
                                                src={getImageSource(
                                                    ImageConstants.SIGNUP_WEB
                                                )}
                                            />
                                            <img
                                                alt=''
                                                className='signup-image-mobile'
                                                src={getImageSource(
                                                    ImageConstants.SIGNUP_MOBILE
                                                )}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {isSignupSuccess && <SignupSuccessComponent name={name} />}
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 p-4'>
                            <div className='row center-box p-2'>
                                {this.state.activeTabIndex == Constants.ACTIVE_TAB_SIGN_UP &&
                                    this.state.boardDropdownData &&
                                    this.state.staffTypesDropdown &&
                                    this.state.countryCodeDropdown &&
                                    this.state.classDropdownData && (
                                        <SchoolSignUp
                                            classes={this.state.classDropdownData}
                                            boards={this.state.boardDropdownData}
                                            countries={this.state.countryCodeDropdown}
                                            roles={this.state.staffTypesDropdown}
                                            hashedCountryCode={this.state.hashedCountryCode}
                                            isSignUpfailed={this.state.isSignUpfailed}
                                            isEmailAlreadyRegistered={
                                                this.state.isEmailAlreadyRegistered
                                            }
                                            delegate={this}
                                            setSignupSuccess={this.setSignupSuccess}
                                            {...this.props}
                                        ></SchoolSignUp>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default SchoolSignupComponent
